//制造业重大项目方向

const indexAdmin = () => import('./indexAdmin');
const edit = () => import('./edit.vue');
const info = () => import('./info.vue')

export default {
  routes: [
    {
      path: '/smes/train/2024/indexAdmin',
      name: 'smes_train_v2024_index_admin',
      component: indexAdmin,
      meta: {public: true}
    },
    {
      path: '/smes/train/2024/edit',
      name: 'smes_train_v2024_edit',
      component: edit,
      meta: {public: true}
    },
    {
      path: '/smes/train/2024/info',
      name: 'smes_train_v2024_info',
      component: info,
      meta: {public: true}
    },
  ]
}



// WEBPACK FOOTER //
// ./src/components/smes/train/v2024/router.js